import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getClientConfig } from '../../config/clientConfig';
import HELPERS from '../../utils/helper';
import { Toast, toastMsgConfig } from '../toast';
import apis from '../../config/apis';
import './template11.css';

// University Template - Prestigious & Formal Design
class EnquiryTemplate11 extends Component {
  constructor(props) {
    super(props);
    const clientConfig = getClientConfig(props.clientId);

    if (!clientConfig) {
      this.state = {
        loader: false,
        clientConfig: null,
        formData: {},
        errors: {},
        disabled: true,
        areas: [],
        courses: [],
      };
      return;
    }

    this.state = {
      loader: false,
      formData: {
        name: '',
        phone: '',
        email: '',
        area: '',
        course: '',
        message: ''
      },
      errors: {},
      disabled: false,
      areas: [],
      clientConfig: clientConfig,
      courses: clientConfig.courses,
    };
  }

  componentDidMount() {
    if (this.state.clientConfig) {
      this.fetchAreas();
      this.fetchCourses();
    }
  }

  fetchAreas = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Timezone': 'Asia/Calcutta'
        }
      };
      const areasUrl = apis.getAreasUrl(clientConfig);
      const res = await HELPERS.ApiCall(areasUrl, {}, 'GET', 'proctur', headers);
      if (res.status === 200 && res.data) {
        const result = res.data.result || res.data.data || res.data;
        const areas = [];

        if (Array.isArray(result)) {
          result.forEach(item => {
            if (item.areaList && Array.isArray(item.areaList)) {
              item.areaList.forEach(areaObj => {
                if (areaObj.area) {
                  areas.push(areaObj.area);
                }
              });
            }
          });
        }

        if (areas.length > 0) {
          this.setState({ areas });
        } else {
          this.useFallbackAreas();
        }
      }
    } catch (err) {
      this.useFallbackAreas();
    }
  }

  useFallbackAreas = () => {
    this.setState({
      areas: ['Vesu', 'Adajan', 'Varachha', 'Piplod', 'City Light', 'Athwa', 'Rander', 'Althan']
    });
  }

  fetchCourses = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Timezone': 'Asia/Calcutta'
        }
      };

      const coursesUrl = apis.getCoursesUrl(clientConfig);
      const res = await HELPERS.ApiCall(coursesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const courseList = res.data.data || res.data;
        const courses = [];

        if (Array.isArray(courseList)) {
          courseList.forEach(item => {
            if (item.master_course) {
              courses.push(item.master_course);
            }
          });
        }

        if (courses.length > 0) {
          this.setState({ courses });
        } else {
          this.useFallbackCourses();
        }
      } else {
        this.useFallbackCourses();
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      this.useFallbackCourses();
    }
  }

  useFallbackCourses = () => {
    const { clientConfig } = this.state;
    if (clientConfig && clientConfig.courses) {
      this.setState({ courses: clientConfig.courses });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }));
  }

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Full name is required';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Contact number is required';
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      errors.phone = 'Please enter a valid 10-digit phone number';
    }

    if (formData.email.trim() && !HELPERS.validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (!formData.course.trim()) {
      errors.course = 'Please select an academic program';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    this.setState({ loader: true, disabled: true });

    try {
      const { clientConfig, formData } = this.state;
      const headers = {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Content-Type': 'application/json',
          'source': 'WEB',
          'accept': 'application/json, text/plain, */*'
        }
      };

      const payload = {
        name: formData.name,
        mobile: formData.phone,
        email: formData.email || '',
        comments: formData.message || 'No additional message',
        institute_id: clientConfig.instituteId,
        customComponentList: [],
        mCourseName: formData.course || '',
        state: clientConfig.api.defaults.state,
        city: clientConfig.api.defaults.city,
        area: formData.area || clientConfig.api.defaults.defaultArea
      };

      const apiUrl = apis.getApiUrl(clientConfig);
      const res = await HELPERS.ApiCall(apiUrl, payload, 'POST', 'proctur', headers);

      if (res.status === 200 || res.status === 201) {
        Toast('Your application has been received. The admissions office will review your information and contact you shortly.', toastMsgConfig('s'));
        this.setState({
          formData: {
            name: '',
            phone: '',
            email: '',
            area: '',
            course: '',
            message: ''
          },
          loader: false,
          disabled: false
        });
      } else {
        Toast('Unable to process your application at this time. Please try again.', toastMsgConfig('e'));
        this.setState({ loader: false, disabled: false });
      }
    } catch (error) {
      Toast('Application submission failed. Please contact the admissions office directly.', toastMsgConfig('e'));
      this.setState({ loader: false, disabled: false });
    }
  }

  render() {
    const { formData, errors, disabled, loader, areas, courses, clientConfig } = this.state;

    if (!clientConfig) {
      return null;
    }

    return (
      <div className="template11-container">
        {/* Header */}
        <div className="template11-header">
          <div className="template11-header-content">
            <div className="template11-header-logo">
              <img src={clientConfig.branding.logo} alt={clientConfig.clientName} />
            </div>
            <div className="template11-header-text">
              <h1>{clientConfig.clientName}</h1>
              <p>{clientConfig.branding.heroSubtitle}</p>
            </div>
            <div className="template11-header-badge">
              <i className="fa fa-award"></i>
              <span>{clientConfig.branding.badgeText}</span>
            </div>
          </div>
        </div>

        {/* Page Title */}
        <div className="template11-page-title">
          <div className="template11-page-title-content">
            <h2>Admissions Application</h2>
            <div className="template11-breadcrumb">
              <span>Home</span>
              <i className="fa fa-angle-right"></i>
              <span>Admissions</span>
              <i className="fa fa-angle-right"></i>
              <span>Application Form</span>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="template11-main">
          <div className="template11-container-inner">
            {/* Left Column - Form */}
            <div className="template11-form-column">
              <div className="template11-form-wrapper">
                <div className="template11-form-intro">
                  <h3>Application for Admission</h3>
                  <p>Please complete the form below to begin your application process. All fields marked with an asterisk (*) are mandatory. Our admissions committee will review your application and contact you within 2-3 business days.</p>
                </div>

                <form onSubmit={this.handleSubmit} className="template11-form">
                  <div className="template11-section-title">Personal Information</div>

                  <div className="template11-form-group">
                    <label>Applicant's Full Name <span className="required">*</span></label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={this.handleChange}
                      placeholder="Enter your complete name as per official documents"
                      className={errors.name ? 'error' : ''}
                    />
                    {errors.name && <span className="template11-error"><i className="fa fa-exclamation-circle"></i> {errors.name}</span>}
                  </div>

                  <div className="template11-form-row">
                    <div className="template11-form-group">
                      <label>Contact Number <span className="required">*</span></label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={this.handleChange}
                        placeholder="10-digit mobile number"
                        maxLength="10"
                        className={errors.phone ? 'error' : ''}
                      />
                      {errors.phone && <span className="template11-error"><i className="fa fa-exclamation-circle"></i> {errors.phone}</span>}
                    </div>

                    <div className="template11-form-group">
                      <label>Email Address</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={this.handleChange}
                        placeholder="your.email@example.com"
                        className={errors.email ? 'error' : ''}
                      />
                      {errors.email && <span className="template11-error"><i className="fa fa-exclamation-circle"></i> {errors.email}</span>}
                    </div>
                  </div>

                  <div className="template11-form-group">
                    <label>Residential Area</label>
                    <select
                      name="area"
                      value={formData.area}
                      onChange={this.handleChange}
                    >
                      <option value="">-- Select your residential area --</option>
                      {areas.map((area, index) => (
                        <option key={index} value={area}>{area}</option>
                      ))}
                    </select>
                  </div>

                  <div className="template11-section-title">Academic Details</div>

                  <div className="template11-form-group">
                    <label>Desired Academic Program <span className="required">*</span></label>
                    <select
                      name="course"
                      value={formData.course}
                      onChange={this.handleChange}
                      className={errors.course ? 'error' : ''}
                    >
                      <option value="">-- Select an academic program --</option>
                      {courses.map((course, index) => (
                        <option key={index} value={course}>{course}</option>
                      ))}
                    </select>
                    {errors.course && <span className="template11-error"><i className="fa fa-exclamation-circle"></i> {errors.course}</span>}
                  </div>

                  <div className="template11-form-group">
                    <label>Statement of Purpose / Additional Information</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={this.handleChange}
                      placeholder="Please share your academic interests, career aspirations, relevant achievements, or any specific questions for the admissions committee..."
                      rows="5"
                    ></textarea>
                    <small className="template11-help-text">This helps us understand your goals and provide appropriate guidance.</small>
                  </div>

                  <div className="template11-form-actions">
                    <button
                      type="submit"
                      className="template11-submit-btn"
                      disabled={disabled || loader}
                    >
                      {loader ? (
                        <>
                          <i className="fa fa-spinner fa-spin"></i> Processing Application...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-check-circle"></i> Submit Application
                        </>
                      )}
                    </button>
                    <p className="template11-disclaimer">
                      By submitting this form, you acknowledge that the information provided is accurate and complete to the best of your knowledge.
                    </p>
                  </div>
                </form>
              </div>
            </div>

            {/* Right Column - Sidebar */}
            <div className="template11-sidebar-column">
              {/* Achievements */}
              <div className="template11-sidebar-card template11-achievements">
                <h4>University Excellence</h4>
                <div className="template11-achievement-grid">
                  <div className="template11-achievement-item">
                    <i className="fa fa-users"></i>
                    <strong>{clientConfig.stats.alumni}</strong>
                    <span>Distinguished Alumni</span>
                  </div>
                  <div className="template11-achievement-item">
                    <i className="fa fa-university"></i>
                    <strong>{clientConfig.stats.experience} Years</strong>
                    <span>Academic Legacy</span>
                  </div>
                  <div className="template11-achievement-item">
                    <i className="fa fa-briefcase"></i>
                    <strong>{clientConfig.stats.placement}</strong>
                    <span>Career Placement</span>
                  </div>
                  <div className="template11-achievement-item">
                    <i className="fa fa-globe"></i>
                    <strong>{clientConfig.stats.partners}+</strong>
                    <span>Global Partners</span>
                  </div>
                </div>
              </div>

              {/* Why Choose Us */}
              <div className="template11-sidebar-card">
                <h4>Why Choose Our University?</h4>
                <ul className="template11-features">
                  {clientConfig.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fa fa-check"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Contact Information */}
              <div className="template11-sidebar-card template11-contact-info">
                <h4>Admissions Office</h4>
                <div className="template11-contact-item">
                  <i className="fa fa-phone"></i>
                  <div>
                    <strong>Phone</strong>
                    <p>{clientConfig.contactInfo.phone1}</p>
                    <p>{clientConfig.contactInfo.phone2}</p>
                  </div>
                </div>
                <div className="template11-contact-item">
                  <i className="fa fa-envelope"></i>
                  <div>
                    <strong>Email</strong>
                    <p>{clientConfig.contactInfo.email}</p>
                  </div>
                </div>
                <div className="template11-contact-item">
                  <i className="fa fa-globe"></i>
                  <div>
                    <strong>Website</strong>
                    <p>{clientConfig.contactInfo.website}</p>
                  </div>
                </div>
                <div className="template11-contact-item">
                  <i className="fa fa-map-marker"></i>
                  <div>
                    <strong>Campus Location</strong>
                    <p>{clientConfig.contactInfo.address}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const ConnectedEnquiryTemplate11 = connect(mapStateToProps)(EnquiryTemplate11);
export default ConnectedEnquiryTemplate11;
